import { render, staticRenderFns } from "./pluginManage.vue?vue&type=template&id=32754cd5&"
import script from "./pluginManage.vue?vue&type=script&lang=js&"
export * from "./pluginManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports